export function joinQueries(queries: Record<string, any>) {
    const filteredQueriesStr = Object.entries(queries)
        // Отфильтровываем пустые параметры
        .filter(entry => entry[1] != null && entry[1] != undefined && entry[1] !== '')
        // Если значение параметра строка или число - возвращаем его, если
        // массив - превращаем его в массив массивов формата "ключ-значение"
        .map(entry => {
            if (['string', 'number', 'boolean'].includes(typeof entry[1])) {
                return entry
            } else if (Array.isArray(entry[1]) && entry[1].length) {
                return entry[1].map(value => [entry[0], value])
            }
        })

    // Превращаем полученный массив в массив массивов формата "ключ-значение"
    const queryStr = flattenPairs(filteredQueriesStr)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');

    return queryStr.length ? `?${queryStr}` : '';
}

function flattenPairs(arr: any[]): [string, any] {
    const result: any = [];

    arr.forEach(item => {
        // Проверка, что это массив
        if (Array.isArray(item)) {
            if (item.length === 2 && typeof item[0] === 'string') {
                // Это пара ключ-значение
                result.push(item);
            } else {
                // Возможно, это вложенный массив пар
                // Рекурсивно развернем его
                result.push(...flattenPairs(item));
            }
        }
    });

    return result;
}
